module.exports = __webpack_public_path__ + "static/RoslindaleText-Bold-dc53c4570d1d3291057731e95d200d83.eot";